import React, { useEffect, useState } from "react";
import { rejectSurvey } from "../../../../slices/Employee/survey-CRR.slice";
import { showSuccess } from "../../../../helpers/Notifications/Notification";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Dialog } from "../../../../components/ds";

const RejectionModal = ({ drawerVisible, setDrawerVisible, requestData }) => {
  const { surveyError } = useSelector((state) => state.CRRsurvey);
  const dispatch = useDispatch();
  const history = useHistory();
  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (surveyError) setSubmitting(false);
  }, [surveyError]);

  const close = () => {
    if (submitting) return;
    setDrawerVisible(false);
    setComment("");
    setCommentError("");
  };

  const validate = () => {
    const trimmed = comment.trim();
    if (!trimmed) {
      setCommentError("Please fill the comment to proceed!");
      return false;
    }
    setCommentError("");
    return true;
  };

  const onReject = () => {
    if (!validate()) return;
    setSubmitting(true);
    const data = {
      comment: comment.trim(),
      ...requestData,
    };
    dispatch(
      rejectSurvey(data, () => {
        showSuccess("Assessment Rejected");
        setSubmitting(false);
        history.push("/admin-survey-list");
      })
    );
  };

  const serverCommentError =
    surveyError && typeof surveyError === "object"
      ? surveyError.comment
      : null;
  const errorText = commentError || serverCommentError;

  return (
    <Dialog
      open={Boolean(drawerVisible)}
      onClose={close}
      title="Reject Response"
      width={480}
      footer={
        <>
          <Button variant="secondary" onClick={close} disabled={submitting}>
            CANCEL
          </Button>
          <Button variant="destructive" onClick={onReject} disabled={submitting}>
            {submitting ? "Working…" : "REJECT"}
          </Button>
        </>
      }
    >
      <p style={{ margin: "0 0 12px" }}>
        Please enter your comments and click the button to reject.
      </p>
      <label className="ops-field-label" htmlFor="reject-comment">
        Comments
      </label>
      <textarea
        id="reject-comment"
        className={`ops-textarea${errorText ? " is-invalid" : ""}`}
        placeholder="Enter your comments"
        value={comment}
        onChange={(e) => {
          setComment(e.target.value);
          if (commentError) setCommentError("");
        }}
        onBlur={validate}
        rows={5}
        autoComplete="off"
      />
      {errorText ? <span className="field-error">{errorText}</span> : null}
    </Dialog>
  );
};

export default RejectionModal;
